const CodexLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <path
      fill="#f4511e"
      d="M52,27.3  L62.925,38.225 L52,49.15 L41.075,38.225 L52,27.3 Z M52,25 "
    />
    <path
      fill="#ffa000"
      d="M76.7,52  L65.775,62.925 L54.85,52 L65.775,41.075 L76.7,52 Z M79,52 "
    />
    <path
      fill="#f4511e"
      d="M52,76.7  L41.075,65.775 L52,54.85 L62.925,65.775 L52,76.7 Z M52,79 "
    />
    <path
      fill="#ffa000"
      d="M27.3,52  L38.225,41.075 L49.15,52 L38.225,62.925 L27.3,52 Z M25,52 "
    />
    <path
      fill="#ad1457"
      d="M52,22.7  L38.775,35.925 L27.85,25 L52,0.85 L76.15,25 L65.225,35.925 L52,22.7 Z M52,25 "
    />
    <path
      fill="#00796b"
      d="M81.3,52  L68.075,38.775 L79,27.85 L103.15,52 L79,76.15 L68.075,65.225 L81.3,52 Z M79,52 "
    />
    <path
      fill="#00bcd4"
      d="M52,81.3  L65.225,68.075 L76.15,79 L52,103.15 L27.85,79 L38.775,68.075 L52,81.3 Z M52,79 "
    />
    <path
      fill="#00796b"
      d="M22.7,52  L35.925,65.225 L25,76.15 L0.85,52 L25,27.85 L35.925,38.775 L22.7,52 Z M25,52 "
    />
  </svg>
);

export default CodexLogo;
